import { BASE_URL } from '@constants/endpoints';
import axios from 'axios';
import { fetchConfig } from '@components/config/actions';
import { getServerErrorAction } from '@actions/shared-actions';

export const updateBatch = batch => {
  const request = axios.put(
    `${BASE_URL}/api/user_config/batch`,
    { data: batch }
  );
  return dispatch =>
    request.then(
      () => {
        dispatch(fetchConfig());
      },
      error => dispatch(getServerErrorAction('batch', error))
    );
};

export const updateTime = time => {
  const request = axios.put(
    `${BASE_URL}/api/user_config/time`,
    { data: time }
  );
  return dispatch =>
    request.then(
      () => {
        dispatch(fetchConfig());
      },
      error => dispatch(getServerErrorAction('time', error))
    );
};

export const updateDisplayTimeComponent = display_time => {
  const request = axios.put(
    `${BASE_URL}/api/user_config/display_time_component`,
    { data: display_time }
  );
  return dispatch =>
    request.then(
      () => {
        dispatch(fetchConfig());
      },
      error => dispatch(getServerErrorAction('display_time_component', error))
    );
};

export const updatePdfPreview = pdfPreview => {
  const request = axios.put(
    `${BASE_URL}/api/user_config/pdf_preview`,
    { data: pdfPreview }
  );
  return dispatch =>
    request.then(
      () => {
        dispatch(fetchConfig());
      },
      error => dispatch(getServerErrorAction('pdf_preview', error))
    );
};

export const updateDashboard = dashboard => {
  const request = axios.put(
    `${BASE_URL}/api/user_config/dashboard`,
    { data: dashboard }
  );
  return dispatch =>
    request.then(
      () => {
        dispatch(fetchConfig());
      },
      error => dispatch(getServerErrorAction('dashboard', error))
    );
};

export const updateAdminConsole = adminConsole => {
  const request = axios.put(
    `${BASE_URL}/api/user_config/admin_console`,
    { data: adminConsole }
  );
  return dispatch =>
    request.then(
      () => {
        dispatch(fetchConfig());
      },
      error => dispatch(getServerErrorAction('admin_console', error))
    );
};

// Keeps the "applying theme" overlay (settings/theme.js) visible at least this long, so it's
// still perceptible when the request resolves almost instantly (e.g. on a local backend).
const THEME_OVERLAY_MIN_MS = 2500;

export const updateTheme = theme => {
  const startedAt = Date.now();
  const request = axios.put(
    `${BASE_URL}/api/user_config/theme`,
    { data: theme }
  );
  return dispatch =>
    request.then(
      // A theme switch changes colors.js values and the MUI theme, which aren't reactive
      // the way Redux-driven UI is - reload so everything (including anything already
      // mounted) picks up the new theme consistently, instead of only what re-renders.
      () => {
        const remaining = THEME_OVERLAY_MIN_MS - (Date.now() - startedAt);
        setTimeout(() => window.location.reload(), Math.max(remaining, 0));
      },
      // Re-thrown so the settings page can hide its "applying theme" overlay - a failed
      // request never reloads, so nothing else would clear it.
      error => {
        dispatch(getServerErrorAction('theme', error));
        throw error;
      }
    );
};
